export default __webpack_public_path__ + "static/media/CRM-Account.db030b2e.png";